export enum Month {
  JANUARY = 'JANUARY',
  FEBRUARY = 'FEBRUARY',
  MARCH = 'MARCH',
  APRIL = 'APRIL',
  MAY = 'MAY',
  JUNE = 'JUNE',
  JULY = 'JULY',
  AUGUST = 'AUGUST',
  SEPTEMBER = 'SEPTEMBER',
  OCTOBER = 'OCTOBER',
  NOVEMBER = 'NOVEMBER',
  DECEMBER = 'DECEMBER',
}

export const Months = {
  0: Month.JANUARY,
  1: Month.FEBRUARY,
  2: Month.MARCH,
  3: Month.APRIL,
  4: Month.MAY,
  5: Month.JUNE,
  6: Month.JULY,
  7: Month.AUGUST,
  8: Month.SEPTEMBER,
  9: Month.OCTOBER,
  10: Month.NOVEMBER,
  11: Month.DECEMBER,
};

export const MonthNumbers = {
  [Month.JANUARY]: 0,
  [Month.FEBRUARY]: 1,
  [Month.MARCH]: 2,
  [Month.APRIL]: 3,
  [Month.MAY]: 4,
  [Month.JUNE]: 5,
  [Month.JULY]: 6,
  [Month.AUGUST]: 7,
  [Month.SEPTEMBER]: 8,
  [Month.OCTOBER]: 9,
  [Month.NOVEMBER]: 10,
  [Month.DECEMBER]: 11,
};

export const MonthString = {
  [Month.JANUARY]: 'Gennaio',
  [Month.FEBRUARY]: 'Febbraio',
  [Month.MARCH]: 'Marzo',
  [Month.APRIL]: 'Aprile',
  [Month.MAY]: 'Maggio',
  [Month.JUNE]: 'Giugno',
  [Month.JULY]: 'Luglio',
  [Month.AUGUST]: 'Agosto',
  [Month.SEPTEMBER]: 'Settembre',
  [Month.OCTOBER]: 'Ottobre',
  [Month.NOVEMBER]: 'Novembre',
  [Month.DECEMBER]: 'Dicembre',
};

export const MonthShortString = {
  [Month.JANUARY]: 'Gen',
  [Month.FEBRUARY]: 'Feb',
  [Month.MARCH]: 'Mar',
  [Month.APRIL]: 'Apr',
  [Month.MAY]: 'Mag',
  [Month.JUNE]: 'Giu',
  [Month.JULY]: 'Lug',
  [Month.AUGUST]: 'Ago',
  [Month.SEPTEMBER]: 'Set',
  [Month.OCTOBER]: 'Ott',
  [Month.NOVEMBER]: 'Nov',
  [Month.DECEMBER]: 'Dic',
};
